/* ========================================================================
   GSAP プラグイン登録
======================================================================== */
gsap.registerPlugin(ScrollTrigger);

/* ========================================================================
   コンソールメッセージ
======================================================================== */
console.log('%c MOPPEN Website', 'color: #d4af37; font-size: 24px; font-weight: bold;');
console.log('%cDesigned with love for whiskey enthusiasts', 'color: #f5e6d3; font-size: 14px;');
console.log('%c====================================================', 'color: #3d2817;');

/* ========================================================================
   DOM要素とスクロール設定
======================================================================== */
const lpRoot = document.getElementById('moppen-lp-root');
if (!lpRoot) console.warn('[MOPPEN] root not found.');

const hamburger = lpRoot ? lpRoot.querySelector('#hamburger') : null;
const menuClose = lpRoot ? lpRoot.querySelector('#menu-close') : null;
const fullscreenMenu = lpRoot ? lpRoot.querySelector('#fullscreen-menu') : null;
const menuLinks = lpRoot ? lpRoot.querySelectorAll('.desktop-side-link') : [];
const header = lpRoot ? lpRoot.querySelector('#header') : null;
const phoneViewport = lpRoot ? lpRoot.querySelector('#phone-viewport') : null;
const desktopTopButton = lpRoot ? lpRoot.querySelector('#desktop-top-button') : null;
const heroSection = lpRoot ? lpRoot.querySelector('#home') : null;
const introSection1 = lpRoot ? lpRoot.querySelector('.intro-section-1') : null;
const introSection2 = lpRoot ? lpRoot.querySelector('.intro-section-2') : null;
const productSection = lpRoot ? lpRoot.querySelector('#product') : null;

function getScrollContainer() {
    return (window.matchMedia('(min-width: 1024px)').matches && phoneViewport) ? phoneViewport : window;
}

function scrollToSection(targetElement) {
    if (!targetElement) return;
    const scroller = getScrollContainer();
    if (scroller === window) {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
        const targetTop = targetElement.offsetTop;
        gsap.to(scroller, { scrollTop: Math.max(0, targetTop - 8), duration: 0.75, ease: 'power2.out' });
    }
}

function getScrollTriggerScrollerConfig() {
    return getScrollContainer() === window ? {} : { scroller: phoneViewport };
}

function getCurrentScrollTop() {
    const scroller = getScrollContainer();
    return scroller === window ? (window.pageYOffset || window.scrollY || 0) : scroller.scrollTop;
}

// 処理を軽くするためのモダンな取得方法にブラッシュアップ
function getSectionTop(sectionElement) {
    if (!sectionElement) return Number.POSITIVE_INFINITY;
    const scroller = getScrollContainer();
    const rect = sectionElement.getBoundingClientRect();
    if (scroller === window) {
        return rect.top + window.scrollY;
    } else {
        const scrollerRect = scroller.getBoundingClientRect();
        return rect.top - scrollerRect.top + scroller.scrollTop;
    }
}

function updateMobileHeaderAndHeroState() {
    const isMobile = window.matchMedia('(max-width: 1023px)').matches;
    const scrollTop = getCurrentScrollTop();
    const intro1Top = getSectionTop(introSection1);
    const intro2Top = getSectionTop(introSection2);
    const heroBottom = getSectionTop(heroSection) + (heroSection ? heroSection.offsetHeight : 0);
    const productTop = getSectionTop(productSection);

    const showHeader = isMobile && scrollTop >= Math.max(0, intro1Top - 80);
    const releaseThreshold = Number.isFinite(intro2Top) ? intro2Top - 10 : heroBottom - 60;
    const releaseHeroVideo = scrollTop >= Math.max(0, releaseThreshold);
    const showMobileFixedBuy = isMobile && releaseHeroVideo && scrollTop < Math.max(0, productTop - 40);

    if (header) header.classList.toggle('is-visible', showHeader);
    if (lpRoot) {
        lpRoot.classList.toggle('is-hero-video-released', releaseHeroVideo);
        lpRoot.classList.toggle('is-mobile-buy-visible', showMobileFixedBuy);
    }
}

function openMenu() {
    if (!fullscreenMenu || !header) return;
    fullscreenMenu.classList.add('active');
    header.classList.add('menu-open');
    document.body.style.overflow = 'hidden';
}

function closeMenu() {
    if (fullscreenMenu) fullscreenMenu.classList.remove('active');
    if (header) header.classList.remove('menu-open');
    document.body.style.overflow = '';
}

if (hamburger) hamburger.addEventListener('click', openMenu);
if (menuClose) menuClose.addEventListener('click', closeMenu);

window.addEventListener('scroll', updateMobileHeaderAndHeroState, { passive: true });
if (phoneViewport) phoneViewport.addEventListener('scroll', updateMobileHeaderAndHeroState, { passive: true });
window.addEventListener('resize', updateMobileHeaderAndHeroState);

menuLinks.forEach(link => {
    link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('href');
        closeMenu();
        setTimeout(() => {
            const targetElement = (lpRoot && targetId) ? lpRoot.querySelector(targetId) : null;
            scrollToSection(targetElement);
        }, link.classList.contains('menu-link') ? 500 : 0);
    });
});

if (desktopTopButton) {
    desktopTopButton.addEventListener('click', () => {
        const scroller = getScrollContainer();
        if (scroller === window) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            gsap.to(scroller, { scrollTop: 0, duration: 0.8, ease: 'power2.out' });
        }
    });
}

/* ========================================================================
   ヒーローセクション アニメーション
======================================================================== */
window.addEventListener('load', () => {
    gsap.from('#moppen-lp-root .hero-media', { scale: 1.08, duration: 1.8, ease: 'power2.out' });
    gsap.from('#moppen-lp-root .hero-subtitle', { y: 30, opacity: 0, duration: 1, ease: 'power2.out' });
    gsap.from('#moppen-lp-root .hero-title', { y: 30, opacity: 0, duration: 1, delay: 0.3, ease: 'power2.out' });
    gsap.from('#moppen-lp-root .hero-logo', { opacity: 0, duration: 1.5, delay: 0.5, ease: 'power2.out' });
    gsap.from('#moppen-lp-root .scroll-indicator', { opacity: 0, duration: 1, delay: 2, ease: 'power2.out' });
});

/* ========================================================================
   ★追加：2スクロール目で背景動画が暗くなる（kimiwa.jp風）エフェクト
======================================================================== */
const videoOverlay = lpRoot ? lpRoot.querySelector('.video-overlay') : null;
if (videoOverlay) {
    gsap.to(videoOverlay, {
        opacity: 1, // 暗くする
        ease: "none",
        scrollTrigger: {
            trigger: ".intro-section-1",
            start: "top 80%", // intro-section-1が下から入ってきたら開始
            end: "top 20%",   // intro-section-1が上部に到達する頃に完了
            scrub: true,
            ...getScrollTriggerScrollerConfig()
        }
    });
}

/* ========================================================================
   スクロールトリガー アニメーション
======================================================================== */
(lpRoot ? Array.from(lpRoot.querySelectorAll('.fade-in-up')) : []).forEach((elem) => {
    gsap.from(elem, {
        y: 30, opacity: 0, duration: 1,
        scrollTrigger: {
            trigger: elem, start: 'top 80%', toggleActions: 'play none none reverse', ...getScrollTriggerScrollerConfig()
        }
    });
});

(lpRoot ? Array.from(lpRoot.querySelectorAll('.slide-up')) : []).forEach((elem) => {
    gsap.from(elem, {
        y: 50, opacity: 0, duration: 1, ease: 'power2.out',
        scrollTrigger: {
            trigger: elem, start: 'top 85%', ...getScrollTriggerScrollerConfig()
        }
    });
});

/* ========================================================================
   HOW TO タイムライン アニメーション
======================================================================== */
gsap.fromTo('#moppen-lp-root .timeline-line',
    { scaleY: 0 },
    {
        scaleY: 1, ease: 'none', overwrite: true,
        scrollTrigger: {
            trigger: '#moppen-lp-root .howto', start: 'top 50%', end: 'bottom 50%', scrub: 1, invalidateOnRefresh: true,
            onLeaveBack: () => gsap.set('#moppen-lp-root .timeline-line', { scaleY: 0 }),
            ...getScrollTriggerScrollerConfig()
        }
    }
);

(lpRoot ? Array.from(lpRoot.querySelectorAll('.howto-step')) : []).forEach((step) => {
    gsap.from(step, {
        x: step.classList.contains('step-left') ? -50 : 50, opacity: 0, duration: 0.8, ease: 'power2.out',
        scrollTrigger: { trigger: step, start: 'top 80%', ...getScrollTriggerScrollerConfig() }
    });
});

/* ========================================================================
   パララックス / Swiper / 画像遅延読み込み 等の既存コード
======================================================================== */
(lpRoot ? lpRoot.querySelectorAll('.parallax-image') : []).forEach((image) => {
    const speed = parseFloat(image.getAttribute('data-speed')) || 0.4;
    const frameMove = speed * 48;
    const imageInner = image.querySelector('img');

    gsap.fromTo(image, { y: -frameMove, force3D: true }, {
        y: frameMove, ease: 'none', force3D: true,
        scrollTrigger: { trigger: '#moppen-lp-root .parallax-section', start: 'top bottom', end: 'bottom top', scrub: 1.2, invalidateOnRefresh: true, ...getScrollTriggerScrollerConfig() }
    });

    if (imageInner) {
        gsap.fromTo(imageInner, { y: frameMove, scale: 1.12, force3D: true }, {
            y: -frameMove, scale: 1.12, ease: 'none', force3D: true,
            scrollTrigger: { trigger: '#moppen-lp-root .parallax-section', start: 'top bottom', end: 'bottom top', scrub: 1.2, invalidateOnRefresh: true, ...getScrollTriggerScrollerConfig() }
        });
    }
});

/* ========================================================================
   Swiper / 画像遅延読み込み 等の既存コード
======================================================================== */
// 1つ目の自動スライダー（既存）
const autoSlider = lpRoot ? new Swiper(lpRoot.querySelector('.auto-slider'), {
    slidesPerView: 'auto', spaceBetween: 20, loop: true, loopAdditionalSlides: 6, speed: 7000, allowTouchMove: false,
    autoplay: { delay: 0, disableOnInteraction: false, pauseOnMouseEnter: false, reverseDirection: false }
}) : null;

// ★追加：2つ目の自動スライダー（auto-slider2）
const autoSlider2 = lpRoot ? new Swiper(lpRoot.querySelector('.auto-slider2'), {
    slidesPerView: 'auto', spaceBetween: 20, loop: true, loopAdditionalSlides: 6, speed: 7000, allowTouchMove: false,
    // 【プロのワンポイント】 2段目は「reverseDirection: true」にして逆向きに流すと、一気に高級感と動きの厚みが出ます！
    autoplay: { delay: 0, disableOnInteraction: false, pauseOnMouseEnter: false, reverseDirection: false }
}) : null;

// 木材用の手動スライダー（既存）
const woodSlider = lpRoot ? new Swiper(lpRoot.querySelector('.wood-slider'), {
    slidesPerView: 1, spaceBetween: 16, loop: false, speed: 500, effect: 'slide',
    navigation: { nextEl: '.wood-slider-next', prevEl: '.wood-slider-prev' }
}) : null;
(lpRoot ? lpRoot.querySelectorAll('a[href^="#"]') : []).forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        const href = this.getAttribute('href');
        if (href !== '#' && href.length > 1) {
            e.preventDefault();
            scrollToSection(lpRoot ? lpRoot.querySelector(href) : null);
        }
    });
});

if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const img = entry.target;
                if (img.dataset.src) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
                observer.unobserve(img);
            }
        });
    });
    (lpRoot ? lpRoot.querySelectorAll('img[data-src]') : []).forEach(img => imageObserver.observe(img));
}

if (window.innerWidth > 1024) {
    const cursor = document.createElement('div');
    cursor.classList.add('custom-cursor');
    document.body.appendChild(cursor);
    cursor.style.cssText = `position: fixed; width: 20px; height: 20px; border: 2px solid #d4af37; border-radius: 50%; pointer-events: none; z-index: 9999; transition: transform 0.15s ease; mix-blend-mode: difference;`;

    document.addEventListener('mousemove', (e) => {
        cursor.style.left = e.clientX - 10 + 'px';
        cursor.style.top = e.clientY - 10 + 'px';
    });

    (lpRoot ? lpRoot.querySelectorAll('a, button, .swiper-button-prev, .swiper-button-next') : []).forEach(elem => {
        elem.addEventListener('mouseenter', () => cursor.style.transform = 'scale(1.5)');
        elem.addEventListener('mouseleave', () => cursor.style.transform = 'scale(1)');
    });
}

function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => { clearTimeout(timeout); func(...args); };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

const handleResize = debounce(() => ScrollTrigger.refresh(), 250);
window.addEventListener('resize', handleResize);
window.addEventListener('orientationchange', () => setTimeout(() => ScrollTrigger.refresh(), 200));

window.addEventListener('load', () => {
    updateMobileHeaderAndHeroState();
    const heroVideo = lpRoot ? lpRoot.querySelector('.hero-video') : null;
    if (heroVideo && heroVideo.readyState < 2) heroVideo.load();
    setTimeout(() => ScrollTrigger.refresh(), 250);
    console.log('✨ All resources loaded successfully');
});